export const noImage =
    "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/no-image.png";

export const s3ImageUrl =
    "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/";
